module.exports = __webpack_public_path__ + "img/IMG_2542-2.5d1ce7e6.jpg";